import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import Detail from "@/pages/Detail";
import Batch from "@/pages/Batch";
import Pricing from "@/pages/Pricing";
import BillingReturn from "@/pages/BillingReturn";
import Share from "@/pages/Share";
import Gallery from "@/pages/Gallery";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center"><div className="orbital" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <div className="App">
      <div className="cosmos-bg" aria-hidden />
      <div className="cosmos-nebula" aria-hidden />
      <div className="cosmos-vignette" aria-hidden />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/share/:token" element={<Share />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/billing/return" element={<BillingReturn />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/batch" element={<Protected><Batch /></Protected>} />
            <Route path="/library" element={<Protected><Library /></Protected>} />
            <Route path="/image/:id" element={<Protected><Detail /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
